export function isNumericOnly(input) {
  return /^\d*$/.test(input);
}
